<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep :cardName="prop.cardName" :currentStep="5">
    </PogressBarStep>
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content']">
          <div :class="[deviceType, 'separator']">
            <div :class="[deviceType, 'container']">
              <div class="full">
                <DropDown
                  v-model="prop.emergencyContact.title"
                  :selectedOption="prop.emergencyContact.title"
                  :options="titleList"
                  :value="titleList"
                  field="title"
                  :placeholder="t('ccOnBoarding.emergencyContact.title')"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div class="full">
                <InputText
                  class="inputcomponent"
                  v-model="prop.emergencyContact.relativeName"
                  :value="prop.emergencyContact.relativeName"
                  field="immediateName"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.emergencyContact.immediateName')
                  "
                  :max-length="100"
                  :autocomplete="'new-password'"
                  @keydown="handleNameKeyDown"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div class="full">
                <DropDown
                  v-model="prop.emergencyContact.relationship"
                  :selectedOption="prop.emergencyContact.relationship"
                  :options="relationshipList"
                  :value="relationshipList"
                  field="relationship"
                  :placeholder="t('ccOnBoarding.emergencyContact.relationship')"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container3']">
              <div
                v-if="deviceType == 'Mobile'"
                :class="[deviceType, 'flex_third']"
              >
                <div :class="[deviceType, 'margin']">
                  <DropDown
                    v-model="prop.emergencyContact.countryCode"
                    :selectedOption="prop.emergencyContact.countryCode"
                    :options="mobileCountryCodeList.slice(0, 2)"
                    :value="mobileCountryCodeList.slice(0, 2)"
                    field="countryCode"
                    :placeholder="''"
                    :default="true"
                    :default-value="'60'"
                    :is-country-code="true"
                  />
                </div>
              </div>
              <div v-else :class="[deviceType, 'flex_third']">
                <div :class="[deviceType, 'margin']">
                  <DropDown
                    v-model="prop.emergencyContact.countryCode"
                    :selectedOption="prop.emergencyContact.countryCode"
                    :options="mobileCountryCodeList.slice(0, 2)"
                    :value="mobileCountryCodeList.slice(0, 2)"
                    field="countryCode"
                    :placeholder="
                      t('ccOnBoarding.emergencyContact.countryCode')
                    "
                    :default="true"
                    :default-value="'60'"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'flex_inputText']">
                <div :class="[deviceType, 'margin']">
                  <InputText
                    class="inputcomponent"
                    v-model="prop.emergencyContact.mobileNo"
                    field="mobileNo"
                    :required="false"
                    :placeholder="t('ccOnBoarding.emergencyContact.mobileNo')"
                    :max-length="
                      prop.emergencyContact.countryCode == '65' ? 9 : 10
                    "
                    :min-length="
                      prop.emergencyContact.countryCode == '65' ? 8 : 9
                    "
                    :autocomplete="'new-password'"
                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                    :number="'true'"
                    :type="'text'"
                    :pattern="'[0-9]*'"
                    :inputmode="'numeric'"
                    :trim="true"
                    @keydown.enter.prevent="handleEnterKey"
                  />
                </div>
              </div>
            </div>
          </div>
          <div :class="[deviceType, 'buttoncontainer']">
            <button
              v-if="prop.summarySetting.emergencyContactJump == false"
              :class="[deviceType, 'left-button']"
              type="button"
              @click="handleBack"
            >
              {{ t("ccOnBoarding.back") }}
            </button>
            <div v-else :class="[deviceType, 'left-button:disabled']"></div>
            <button
              v-if="prop.summarySetting.emergencyContactJump == false"
              :disabled="isBtnDisabled"
              :class="[deviceType, 'right-button']"
            >
              {{ t("ccOnBoarding.next") }}
            </button>
            <button
              v-else
              :disabled="isBtnDisabled"
              :class="[deviceType, 'summary-button']"
            >
              {{ t("ccOnBoarding.backToSummary") }}
            </button>
          </div>
        </div>
      </div>
    </Form>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  onMounted,
  computed,
  onBeforeMount,
  type PropType,
  watch,
} from "vue";
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import DropDown from "./components/NewDropDownComponent.vue";
import InputText from "./components/NewInputTextComponent.vue";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type { EmergencyContact } from "@/interface/FormCC";
import type { SummarySetting } from "@/interface/FormCC";
import { deviceDetect } from "mobile-device-detect";

const deviceType = ref("");

const prop = defineProps({
  emergencyContact: {
    type: Object as PropType<EmergencyContact>,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  cardName: {
    type: String,
    required: true,
  },
  mobileNo: {
    type: String,
    required: true,
  },
  summarySetting: {
    type: Object as PropType<SummarySetting>,
    required: true,
  },
  pfExpired: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
  },
});

const { t } = i18n.global;

//List
const titleList = ref([]);
const relationshipList = ref([]);
const mobileCountryCodeList = ref([]);

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

onBeforeMount(() => {
  MasterService.getMasterData()
    .then((res) => {
      titleList.value = res.data.titleType;
      relationshipList.value = res.data.relativeType;
      mobileCountryCodeList.value = res.data.mobileNoCountryCode;
    })
    .catch((e) => {});
});

const schema = computed(() => {
  const countryCode = prop.emergencyContact.countryCode == "60";
  return {
    title: "required",
    relationship: "required",
    immediateName:
      prop.pfExpired || prop.type == "CR_SL"
        ? "required"
        : "required|nameFormat",
    countryCode: "required",
    // mobileNo: countryCode
    //   ? "requiredNumber|minLengthNumber:7|maxLengthNumber:10|numberFormat|mobileMY"
    //   : "requiredNumber|minLengthNumber:7|maxLengthNumber:10|numberFormat|mobileSG",
    mobileNo: countryCode
      ? `requiredNumber|minLengthNumber:9|maxLengthNumber:10|numberFormat|sameMobile:${
          prop.mobileNo
        },${prop.emergencyContact.countryCode + prop.emergencyContact.mobileNo}`
      : `requiredNumber|minLengthNumber:8|maxLengthNumber:9|numberFormat|sameMobile:${
          prop.mobileNo
        },${
          prop.emergencyContact.countryCode + prop.emergencyContact.mobileNo
        }`,
  };
});

const onInvalidSubmit = () => {};

const isBtnDisabled = computed(() => {
  return (
    prop.emergencyContact.title == "" ||
    prop.emergencyContact.relativeName == "" ||
    prop.emergencyContact.relationship == "" ||
    prop.emergencyContact.countryCode == "" ||
    prop.emergencyContact.mobileNo == ""
  );
});

const emit = defineEmits(["nextStep", "previousStep", "submit"]);
const onSubmit = () => {
  emit("submit");
};

const handleBack = () => {
  emit("previousStep");
};

const handleNameKeyDown = (event: KeyboardEvent) => {
  const isSymbol = /^[a-zA-Z@#()_:\/.,'\-\s]+$/.test(event.key);
  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    !isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

watch(
  () => prop.emergencyContact.countryCode,
  (newValue) => {
    if (newValue) {
      prop.emergencyContact.mobileNo = "";
    }
  }
);

const handleEnterKey = () => {};
</script>
<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.flex_half {
  width: 50%;
}

.separator {
  margin-bottom: 37px;
  border-bottom: 1px solid #e4e4e4;
}

.flex_dropdown {
  display: flex;
  width: 30%;
  box-sizing: border-box;
  position: relative;
  display: inline-block;
}

.flex_inputText {
  width: 70%;
}

.summary-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
  transition: background-color 0.3s ease;
}

.summary-button:hover {
  background-image: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0.4),
      rgba(255, 255, 255, 0.4)
    ),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:active {
  background-image: linear-gradient(
      120deg,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0.3)
    ),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;

  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.full {
  width: 100%;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* .left-button {
  flex: 0 0 15%;
} */

.agree {
  display: flex;
  align-items: flex-start;
}

.flex_third {
  width: 30%;
}

.container3 {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}
.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}
.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}
.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet),
  .container3:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }
  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .summary-button:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .summary-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 0;
  }

  /* .margin:is(.Desktop, .Tablet) {
    margin-bottom: 10px;
  } */

  .flex_third:is(.Desktop, .Tablet) {
    width: 100%;
  }
}

.container:is(.Mobile) {
  flex-direction: column;
}

.separator .container {
  max-width: none;
}

.content:is(.Mobile) {
  padding: 0;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.container:is(.Mobile) {
  flex-direction: column;
  gap: 0;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.summary-button:is(.Mobile) {
  flex: 0 0 100%;
}

.summary-button:disabled:is(.Mobile) {
  flex: 0 0 100%;
}

.separator:is(.Mobile) {
  margin-bottom: 0;
}

/* .margin:is(.Mobile) {
  margin-bottom: 10px;
} */

.flex_third:is(.Mobile) {
  width: 30%;
}
</style>
